import React from 'react';

const TermsOfUse = () => (
  <div style={{ padding: '0 15px' }}>
    <ol>
      <li>
        <b>Geltung</b>
        <ol type="a">
          <li>
            Gegenstand dieser Nutzungsbedingungen ist die Regelung der Nutzung der Applikation
            „BIWAPP“ (nachfolgend „Applikation“) der Marktplatz GmbH - Agentur für Web & App,
            Stresemannstraße 6, 21335 Lüneburg (nachfolgend „Anbieter“). Die Applikation ist eine
            Serviceanwendung für mobile Endgeräte, die grundsätzlich kostenfrei für Nutzer zur
            Verfügung steht.
          </li>
          <li>
            Bedingungen des Nutzers, die von den vorliegenden Nutzungsbedingungen abweichen, werden
            widersprochen. Sie werden nur wirksam, wenn sie die Anbieterin schriftlich gegenüber dem
            Nutzer bestätigt.
          </li>
          <li>
            Mit dem Download der Applikation durch den Nutzer werden diese Nutzungsbedingungen in
            das Vertragsverhältnis zwischen der Anbieterin und dem Nutzer einbezogen. Die
            Nutzungsbedingungen sind jederzeit unter dem Menüpunkt „Info/Nutzungsbedingungen“ der
            Applikation einsehbar.
          </li>
        </ol>
      </li>
      <li>
        <b>Leistungsumfang; Nutzungsumfang</b>
        <ol type="a">
          <li>
            Der Anbieter bietet über die Applikation eigene mobile Serviceanwendungen an und bindet
            Serviceanwendungen Dritter ein.
          </li>
          <li>
            Die Applikation wird in ihrem jeweils gegenwärtigen Zustand zur Verfügung gestellt. Die
            Applikation sowie die in ihrem Rahmen angebotenen oder eingebunden Dienste können durch
            den Anbieter jederzeit verändert, erweitert, beschränkt oder beendet werden. Ein
            Anspruch des Nutzers auf die im Rahmen der grundsätzlich kostenfreien Applikation
            angebotenen oder eingebundenen Dienste besteht nicht, dies gilt insbesondere für die
            ständige, ununterbrochene Erreichbarkeit der eigenen mobilen Serviceanwendungen und/oder
            der eingebundenen Serviceanwendungen Dritter.
          </li>
          <li>
            Der Nutzer darf die Applikation nur für eigene persönliche Zwecke verwenden. Die
            Weitergabe von Inhalten sowie deren Nutzung für gewerbliche Zwecke ist untersagt, soweit
            der Anbieter dem nicht ausdrücklich zugestimmt hat.
          </li>
          <li>
            Der Nutzer verpflichtet sich, die eigenen mobilen Serviceanwendungen der Anbieterin und
            die eingebundenen Serviceanwendungen Dritter nicht zu missbrauchen, insbesondere keine
            Sicherheitsvorkehrungen zu umgehen oder Anwendungen auszuführen, die die
            Nutzungsmöglichkeit der Applikation und/oder der damit verbundenen Serviceanwendungen
            beeinträchtigen.
          </li>
        </ol>
      </li>
      <li>
        <b>Gewährleistungs- und Haftungsbeschränkung</b>
        <ol type="a">
          <li>
            Der Anbieter übernimmt keine Gewähr und/oder Haftung für die Netzverfügbarkeit des
            jeweiligen Mobilfunkanbieters und – soweit verfügbar und aktiviert – für die
            Verfügbarkeit der GPS-Ortung, die für die Nutzung der mit der Applikation zur Verfügung
            gestellten eigenen mobilen Serviceanwendungen des Anbieters und der eingebundenen
            Serviceanwendungen Dritter Voraussetzung sind.
          </li>
          <li>
            Der Anbieter übernimmt keine Gewähr und/oder Haftung für die inhaltliche Richtigkeit,
            die Aktualität und die Vollständigkeit der Informationen.
          </li>
          <li>
            Der Anbieter übernimmt keine Gewähr und/oder Haftung für die Richtigkeit und
            Vollständigkeit von Informationen im Rahmen von Karten-, Lokalisier-, Zeit-, Chart-,
            Kurs-, Prognosen- oder Veranstaltungsdiensten.
          </li>
          <li>
            Der Anbieter übernimmt keine Gewähr und/oder Haftung dafür, dass die Applikation, deren
            Funktionen oder Inhalte jederzeit zur Verfügung stehen, störungsfrei ablaufen oder die
            von den Nutzern eingegebenen Daten dauerhaft gespeichert und abrufbar sind.
          </li>
          <li>
            Der Anbieter haftet für Schäden, die auf einer vorsätzlichen oder grob fahrlässigen
            Pflichtverletzung der Anbieter, ihrer gesetzlichen Vertreter oder Erfüllungsgehilfen
            beruhen. Der Anbieter haftet weiterhin für sonstige Schäden, die auf einer vorsätzlichen
            oder grob fahrlässigen Pflichtverletzung der Anbieter, ihrer gesetzlichen Vertreter oder
            Erfüllungsgehilfen beruhen.
          </li>
          <li>
            Im Übrigen ist die Haftung des Anbieters ausgeschlossen. Dies gilt auch für die Haftung
            für ihre gesetzlichen Vertreter oder Erfüllungsgehilfen. Der Haftungsausschluss gilt
            nicht, wenn die Anbieter, ihre gesetzlichen Vertreter oder Erfüllungsgehilfen eine
            wesentliche Vertragspflicht (Kardinalpflicht) verletzt haben. Eine Kardinalpflicht ist
            eine Pflicht, auf deren Einhaltung der Nutzer vertrauen durfte und deren Erfüllung die
            ordnungsgemäße Durchführung des Vertrags überhaupt erst ermöglicht.
            Schadensersatzansprüche sind in diesem Fall der Höhe nach auf den typischen
            vorhersehbaren Schaden beschränkt.
          </li>
          <li>
            Die vorstehenden Haftungsbeschränkungen gelten nicht für Ansprüche nach dem
            Produkthaftungsgesetz und/oder wegen des Fehlens einer garantierten Beschaffenheit oder
            einer zugesicherten Eigenschaft.
          </li>
        </ol>
      </li>
      <li>
        <b>Datenschutz</b>
        <ol type="a">
          <li>
            Die Verwendung, Verarbeitung und Nutzung personenbezogener Daten erfolgt gemäß der
            Datenschutzerklärung des Anbieters.
          </li>
          <li>
            Die Datenschutzerklärung ist unter dem Menüpunkt „Info/Datenschutzerklärung“ im Rahmen
            der Applikation jederzeit einsehbar.
          </li>
        </ol>
      </li>
      <li>
        <b>Schutzrechte</b>
        <ol type="a">
          <li>
            Die im Rahmen der Applikation und der eigenen mobilen Serviceanwendungen der Anbieterin
            und der eingebundenen Serviceanwendungen Dritter dargestellten Marken und sonstigen
            gewerblichen Schutzrechte des Anbieters, der Partner oder Dritter werden nur im Rahmen
            der bestehenden Schutzrechte dargestellt, auch wenn eine entsprechende Kennzeichnung
            fehlt. Jede Vervielfältigung und/oder sonstige Nutzung ist ohne Zustimmung der
            Berechtigten untersagt.
          </li>
        </ol>
      </li>
      <li>
        <b>Schlussbestimmungen</b>
        <ol type="a">
          <li>Der Anbieter behält sich vor, die Nutzungsbedingungen jederzeit zu ändern.</li>
          <li>
            Ist oder wird eine Bestimmung dieser Nutzungsbedingungen ganz oder teilweise unwirksam,
            so bleibt die Wirksamkeit der übrigen Bestimmungen hiervon unberührt.
          </li>
          <li>
            Erfüllungsort ist der Sitz des Anbieters. Gerichtsstand für Kaufleute ist der Sitz des
            Anbieters. Ein etwaiger ausschließlicher Gerichtsstand bleibt hiervon unberührt.
          </li>
          <li>Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts.</li>
        </ol>
      </li>
    </ol>
  </div>
);

export default TermsOfUse;



// WEBPACK FOOTER //
// ./src/js/routes/Information/TermsOfUse.js